export const useScheduledEventItemStyles = () => ({
    card: {
        // maxWidth: '353px',
        boxShadow: 'none',
        height: '104px',
        borderRadius: (theme) => theme.spacing(3),
        // px: (theme) => theme.spacing(1),
        py: (theme) => theme.spacing(2),
        overflow: 'hidden'
    },
    imageContainer: {
        position: 'relative',
        height: '72px',
        width: '87px',
        borderRadius: (theme) => theme.spacing(1)
    },
    image: {
        borderRadius: (theme) => theme.spacing(1),
        height: '72px',
        width: '87px',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)'
        }
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        pb: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1
    },
    contentDescriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        flex: 1,
        minWidth: 0
    },
    buttonContainer: {
        display: 'flex',
        gap: 1
    },
    dateRange: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    title: {
        fontWeight: 500,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        pr: 1
    },
    group: {
        color: (theme) => theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    organizerContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        marginTop: 1
    },
    organizerAvatar: {
        width: 32,
        height: 32
    },
    organizerName: {
        color: 'white',
        fontSize: '0.7rem'
    }
});
